import { render, staticRenderFns } from "./search-loader.vue?vue&type=template&id=4f0f4c22"
import script from "./search-loader.vue?vue&type=script&lang=js"
export * from "./search-loader.vue?vue&type=script&lang=js"
import style0 from "./search-loader.vue?vue&type=style&index=0&id=4f0f4c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports